import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import UseOrgDefaultClassificationLevelIdQuery, {
	type useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data,
	type useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$variables,
} from '../hooks/__generated__/useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export function preloadOrgDefaultClassificationLevelIdQuery(): Promise<{
	data: useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<
		useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data,
		useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$variables
	>({
		query: UseOrgDefaultClassificationLevelIdQuery,
	});
}
